import React, { Component } from 'react';
import * as regex from '../../../constants/regex';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';
import * as formatData from '../../functions/formatData';
import dobFormatting from '../../../shared/functions/dobFormatting';
import './ExistingPatientInfoPage.scss';

export class ExistingPatientInfoPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rerender: 1
    };
  }

  isValid() {
    let valid = (
      this.props.patient.firstName &&
      this.props.patient.lastName &&
      this.props.patient.dob &&
      this.props.patient.dob.match(regex.DATE_OF_BIRTH_REGEX) &&
      (!this.props.patient.ssn || this.props.patient.ssn.match(regex.FOUR_DIGITS)) &&
      this.props.patient.phone &&
      this.props.patient.phone.match(regex.NUMERIC_PHONE_NUMBER_REGEX)
    );
    if (this.props.forMe) {
      valid = (
        valid &&
        this.props.patient.email &&
        this.props.patient.email.match(regex.EMAIL_REGEX)
      );
    }
    return !!valid;
  }

  render() {
    const title = "Please give us a little more information so we can find " +
      (this.props.forMe ? "your" : "their") +
      " medical record.";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,

        inputs: [
          [
            {
              type: 'text',
              id: 'firstName',
              label: this.props.forMe ? 'First name' : "Patient’s first name",
              required: true,
              requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " first name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => { this.props.webAppointmentSetPatientFirstName(ev.target.value); },
              existingContent: this.props.patient.firstName || undefined,
              maxLength: '140'
            }
          ],
          [
            {
              type: 'text',
              id: 'lastName',
              className: '3column',
              label: this.props.forMe ? 'Last name' : "Patient’s last name",
              required: true,
              requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " last name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => { this.props.webAppointmentSetPatientLastName(ev.target.value); },
              existingContent: this.props.patient.lastName || undefined,
              maxLength: '140'
            }
          ]
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
            {
              type: 'text',
              id: 'phoneNumber',
              label: this.props.forMe ? "Phone number" : "Patient’s phone number",
              required: true,
              requiredError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " phone number with the area code.",
              patternMatch: regex.NUMERIC_PHONE_NUMBER_REGEX,
              patternMatchError: "Please enter " + (this.props.forMe ? "your" : "the patient’s") + " phone number with the area code.",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => {
                let newValues = formatData.formatPhone(ev.target.value, ev.target.selectionStart);
                this.props.webAppointmentSetPatientPhone(newValues.value);
                return newValues;
              },
              existingContent: this.props.patient.phone
            },
          this.props.forMe ?
            {
              type: 'text',
              id: 'email',
              label: "Email",
              required: true,
              requiredError: "Please enter your email address in this format: yourname@example.com",
              patternMatch: regex.EMAIL_REGEX,
              patternMatchError: "Please enter your email address in this format: yourname@example.com",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error",
              onChange: (ev) => {
                const formattedEmail = ev.target.value.replace(/\s/g, '');
                this.props.webAppointmentSetPatientEmail(formattedEmail);
                return formattedEmail;
              },
              existingContent: this.props.patient.email
            } : null,
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          {
            id: 'dob',
            key: "dob-" + this.state.rerender,
            type: 'text',
            label: this.props.forMe ? 'Date of birth' : "Patient’s date of birth",
            helperText: "Date format: mm/dd/yyyy",
            placeholderText: 'mm/dd/yyyy',
            required: true,
            requiredError: "Please enter " + (this.props.forMe ? "your" : "their") + " date of birth.",
            patternMatch: regex.DATE_OF_BIRTH_REGEX,
            patternMatchError: "Please enter a valid date",
            validateOnBlur: true,
            validateOnChange: true,
            validationErrorClass: "web-appointment__error",
            onChange: (ev) => { this.props.webAppointmentSetPatientDob(ev.target.value); },
            onKeyUp: (ev) => {
              dobFormatting(ev, this, this.props.webAppointmentSetPatientDob);
            },
            existingContent: this.props.patient.dob || undefined
          },
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          {
            type: 'text',
            id: 'ssn',
            key: 'ssn',
            label: "The last 4 digits of " + (this.props.forMe ? "your" : "the patient’s") + " Social Security Number (Optional)",
            patternMatch: regex.FOUR_DIGITS,
            patternMatchError: "Please enter 4 digits.",
            validateOnBlur: true,
            validateOnChange: true,
            validationErrorClass: "web-appointment__error",
            helperText: "This is optional. This is a helpful identifier when patients have the same last name.",
            onChange: (ev) => {
              let newValues = formatData.formatDigitString(ev.target.value, ev.target.selectionStart, 4);
              this.props.webAppointmentSetPatientSsn(newValues.value);
              return newValues;
            },
            existingContent: this.props.patient.ssn
          }
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: 'Next',
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

ExistingPatientInfoPage.propTypes = {
  patient: defaultState.patientPropType,
  forMe: PropTypes.bool.isRequired,
  webAppointmentSetPatientDob: PropTypes.func.isRequired,
  webAppointmentSetPatientEmail: PropTypes.func.isRequired,
  webAppointmentSetPatientFirstName: PropTypes.func.isRequired,
  webAppointmentSetPatientLastName: PropTypes.func.isRequired,
  webAppointmentSetPatientPhone: PropTypes.func.isRequired,
  webAppointmentSetPatientSsn: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    patient: state.webAppointmentForm.patient,
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetPatientDob: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientDob(value)),
    webAppointmentSetPatientEmail: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientEmail(value)),
    webAppointmentSetPatientFirstName: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientFirstName(value)),
    webAppointmentSetPatientLastName: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientLastName(value)),
    webAppointmentSetPatientPhone: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientPhone(value)),
    webAppointmentSetPatientSsn: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientSsn(value)),
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(ExistingPatientInfoPage);
